export const environment = {
  lang: 'en',
};
